module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.674f50d2.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 969
// module chunks = 7